import { render, staticRenderFns } from "./PaymentMethods.vue?vue&type=template&id=4d4b4fb8&"
import script from "./PaymentMethods.vue?vue&type=script&lang=js&"
export * from "./PaymentMethods.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports